import * as React from 'react';
import { cn } from './cn';

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  /** Keys rendered as separate caps, e.g. `['⌘', 'Z']`. Falls back to children. */
  keys?: string[];
  size?: 'sm' | 'md';
}

/**
 * Keyboard shortcut hint. Always LTR + `ltr` isolation: shortcuts are never mirrored,
 * even inside Hebrew sentences.
 */
export const Kbd = React.forwardRef<HTMLElement, KbdProps>(function Kbd(
  { keys, size = 'sm', className, children, ...props },
  ref,
) {
  const cap = cn(
    'inline-flex items-center justify-center rounded-xs border border-line-strong bg-surface',
    'font-mono text-ink-2 shadow-xs select-none',
    size === 'sm' ? 'text-2xs h-5 min-w-5 px-1' : 'h-6 min-w-6 px-1.5 text-xs',
  );
  return (
    <kbd
      ref={ref}
      dir="ltr"
      className={cn('inline-flex items-center gap-0.5 align-middle', className)}
      style={{ unicodeBidi: 'isolate' }}
      {...props}
    >
      {keys ? keys.map((k) => <span key={k} className={cap}>{k}</span>) : <span className={cap}>{children}</span>}
    </kbd>
  );
});
